import { ReactNode } from "react";
import { createPortal } from "react-dom";

/**
 * Renders children into document.body, escaping any ancestor stacking context
 * (e.g. framer-motion `transform` on card roots) that would otherwise trap a
 * `position: fixed` modal and leave it painted under sibling content.
 *
 * Keep this OUTSIDE <AnimatePresence> so AnimatePresence stays directly bound
 * to its keyed motion children and exit animations keep working.
 */
export function ModalPortal({ children }: { children: ReactNode }) {
  if (typeof document === "undefined") return null;
  return createPortal(children, document.body);
}

export default ModalPortal;
